export enum UnderwriterContentType {
  PurchaseDisclaimer = 'PURCHASEDISCLAIMER',
  CoiEmerContactDesc = 'COIEMERCONTACTDESC',
  CoiEmerContactEmail = 'COIEMERCONTACTEMAIL',
  CoiEmerContactNumber = 'COIEMERCONTACTNUMBER',
  CoiEmerContactNumberSecondary = 'COIEMERCONTACTNUMBERSECONDARY',
  UnderwrittenBy = 'UNDERWRITTENBY',
  DependentDefinitionText = 'DEPENDENTDEFINITIONTEXT',
  ResidentDefinitionText = 'RESIDENTDEFINITIONTEXT',
  BuyingWhileOverseasDisclaimer = 'BUYINGWHILEOVERSEASDISCLAIMER',
  PreExMedicalConditionDisclaimer = 'PREEXMEDICALCONDITIONDISCLAIMER',
  SpecifiedItemOptionText = 'SPECIFIEDITEMOPTIONTEXT',
  AdventureActivityConditionsText = 'ADVENTUREACTIVITYCONDITIONSTEXT',
  TermsAndConditionsKey = 'TERMSANDCONDITIONSKEY',
  BenefitsLimitDescriptionText = 'BENEFITSLIMITDESCRIPTIONTEXT',
  AgeAmbiguityModalText = 'AGEAMBIGUITYMODALTEXT',
}
